import { ButtonColor, ButtonVariant } from './Button.types'
import { DefaultTheme, ThemedCssFunction } from 'styled-components'
import tw, { css, styled } from 'twin.macro'

export const ButtonVariantStyles: Record<ButtonVariant, ReturnType<ThemedCssFunction<DefaultTheme>>> = {
    normal: css<{ $color: ButtonColor }>`
        ${tw`text-main-bodyCTABannerButton`}
        ${({ $color }) => {
            switch ($color) {
                case 'theme':
                    return tw`bg-main-bgCTABannerButton`
                case 'red':
                    return tw`bg-secondaryRed-300`
                case 'blue':
                    return tw`bg-secondaryBlue-300`
                default:
                    return tw`bg-secondaryBlue-300`
            }
        }}
        :hover:not(:disabled) {
            ${({ $color }) => {
                switch ($color) {
                    case 'theme':
                        return tw`bg-main-bgCTABannerButton opacity-95`
                    case 'red':
                        return tw`bg-secondaryRed-200`
                    case 'blue':
                        return tw`bg-secondaryBlue-200`
                    default:
                        return tw`bg-grey-600`
                }
            }}
        }
    `,
    text: css<{ $color: ButtonColor }>`
        background: none;

        ${({ $color }) => {
            switch ($color) {
                case 'red':
                    return tw`text-secondaryRed-200`
                case 'blue':
                    return tw`text-secondaryBlue-200`
                default:
                    return tw`text-basic-darkBlue`
            }
        }}
        :hover:not(:disabled) {
            ${({ $color }) => {
                switch ($color) {
                    case 'theme':
                        return tw`bg-main-bgMain`
                    case 'red':
                        return tw`bg-secondaryRed-100`
                    case 'blue':
                        return tw`bg-secondaryBlue-100`
                    default:
                        return tw`bg-secondaryBlue-100`
                }
            }}
        }
    `
}

export const ButtonLeftIconContainer = styled.span`
    ${tw`flex justify-center items-center`}
    padding-right: 0.313rem;
`

export const ButtonRightIconContainer = styled.span`
    ${tw`flex justify-center items-center`}
    padding-left: 0.313rem;
`

export const ButtonRoot = styled.button<{ $variant: ButtonVariant; $color: ButtonColor }>`
    /* Layout  */
    ${tw`flex justify-center items-center`}

    padding: 1.10rem 2.25rem;
    border-radius: 2.375rem;
    border: none;

    /* Font  */
    font-style: normal;
    font-weight: 600;
    font-size: 1.125rem;
    line-height: 1.25rem;
    text-align: center;
    letter-spacing: 0.004em;
    text-decoration: none;

    :disabled {
        opacity: 0.6;
        pointer-events: none;
    }

    @media only screen and (max-width: 700px) {
        font-size: 1rem;
    }

    ${({ $variant }) => {
        return ButtonVariantStyles[$variant]
    }}
`
